import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const MaxConsumptionText = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray[1]};
  line-height: 100%;
`;

export const CurrentConsumptionText = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.green.default};
  line-height: 100%;
`;

export const ConsumptionValuesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CurrentConsumption = styled.div`
  position: absolute;
  height: 8px;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.colors.green.default};
`;

export const Consumption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TotalConsumption = styled.div`
  position: relative;
  height: 8px;
  width: 100%;
  border-radius: 15px;
  background-color: ${({ theme }) => theme.colors.gray[5]};
`;

export const OrderConsumptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const UpgradeButton = styled.button`
  background-color: unset;
  border: unset;
  padding: unset;
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 1rem;
  line-height: 130%;
  font-weight: 600;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }

  & > svg {
    margin-top: -3px;
  }
`;

export const OptionsWrapper = styled.div`
  height: 45px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray[3]};
  display: flex;
  padding: 12px 24px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const TitleHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Divider = styled.div`
  background: linear-gradient(90deg, #25cfbb -6.34%, rgba(37, 207, 187, 0) 95.77%);
  height: 3px;
  width: 198px;
`;

export const Description = styled(TextBase)`
  font-size: 1rem;
  line-height: 100%;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray[1]};
  display: inline-block;
`;

export const PricingValue = styled(TextBase)`
  font-size: 1.5rem;
  line-height: 100%;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray[1]};
  display: inline-block;
`;

export const PlanName = styled(TextBase)`
  font-size: 1.125rem;
  line-height: 130%;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray[1]};
  display: inline-block;
`;

export const PlanNameAndPricingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px 24px 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`;

export const CardWrapper = styled.div`
  min-width: 392px;
  height: 232px;
  background-color: ${({ theme }) => `${theme.colors.info.default}33`};
  border: 2px solid ${({ theme }) => theme.colors.info.default};
  border-radius: 10px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

export const StatusText = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const PeriodWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CancelationButton = styled.button`
  background-color: unset;
  border: unset;
  padding: unset;
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.gray[2]};
  font-size: 1rem;
  line-height: 130%;
  font-weight: 400;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    filter: brightness(1.1);
  }

  &:active {
    filter: brightness(0.9);
  }
`;
